export const CHART_AXIS_STROKE = '#767F90'
export const CARTESIAN_GRID_STROKE = '#292F3E'
export const GRID_OPACITY = 0.5
export const CHART_COLORS = [
  '#BDD1F6',
  '#BD9BF3',
  '#339AF0',
  '#E9F0FC',
  '#7E848E',
  '#576B90',
  '#58A3C1',
  '#B4EDAD',
  '#D790E9',
  '#F0C99B',
  '#5EEAD4',
  '#EC4899',
  '#EAEA4D',
  '#B64545',
  '#5EC35E',
]

export const CHART_TITLE_STYLES = {
  fill: 'white',
  fontSize: 18,
  fontWeight: '500',
  stroke: 'none',
  textAnchor: 'middle',
  x: '50%',
  y: '10.25%',
}

export const DEFAULT_CHART_WIDTH = 'w-full md:w-[48.5%]'

export const LANDING_CHART_COLORS = {
  sUSDe: '#91B3F0',
  Treasuries: '#C2C2C050',
  'USDT/USDC': '#6f6f6f',
}
